module.exports = __webpack_public_path__ + "img/sponsor-placeholder.2d395a8a.png";